import { ClipboardPlus } from "@tamagui/lucide-icons";
import { useContext } from "react";

import { HomeCarePlanContent } from "@/api/generated/models/HomeCarePlanContent";
import { AssistantClientEvent } from "@/api/model/Conversation";
import { ChatNote, LayoutContext, Text } from "@/components";
import { shortBrandName } from "@/config/brand";
import MessageSatisfaction from "@/conversation/MessageSatisfaction";
import HomeCarePlanDisplay from "@/conversation/sidebar/HomeCarePlanDisplay";

const DISCLAIMER = `${shortBrandName} is not a replacement for a clinician.`;
const TITLE = "Your home care plan";
const INTRO =
  "Here is a personalized home care plan based on our conversation.";

export interface HomeCarePlanProps extends AssistantClientEvent {
  content: HomeCarePlanContent;
  type: "home_care_plan";
}

export default function HomeCarePlan({
  content,
  messageId,
  feedback,
  maybeCopy,
  createdAt,
}: HomeCarePlanProps) {
  const { assessment, plan } = content;
  const { setModalContent } = useContext(LayoutContext);

  const handleOpenPlan = () => {
    setModalContent(
      () => (props: any) => (
        <HomeCarePlanDisplay
          assessment={assessment}
          plan={plan}
          generatedAt={createdAt}
          messageId={messageId}
          {...props}
        />
      ),
      { dismissOnOverlayPress: true },
    );
  };

  return (
    <>
      <Text fontFamily="$serif">{INTRO}</Text>
      <ChatNote
        onPress={handleOpenPlan}
        Icon={ClipboardPlus}
        title={TITLE}
        subtitle={assessment || "Tap to view your personalized steps."}
        disclaimer={DISCLAIMER}
      />
      <MessageSatisfaction
        messageId={messageId}
        feedback={feedback}
        onCopy={() =>
          maybeCopy(
            [
              TITLE,
              assessment,
              ...plan.map((step) =>
                [step.title, step.detail].filter(Boolean).join(": ").trim(),
              ),
              DISCLAIMER,
            ]
              .filter(Boolean)
              .join("\n\n"),
          )
        }
      />
    </>
  );
}
